export default __webpack_public_path__ + "static/media/delete512.7a0a5c50.png";